"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchText = searchText;
exports.plainText = plainText;
function deltaText(deltas, refDocIds) {
    return deltas
        .map(item => {
        if (typeof item === 'string')
            return item;
        if (!item || typeof item !== 'object')
            return '';
        const { insert, attributes } = item;
        if (typeof insert !== 'string')
            return '';
        const reference = attributes?.reference;
        if (typeof reference?.pageId === 'string') {
            refDocIds.push(reference.pageId);
        }
        const link = typeof attributes?.link === 'string' ? attributes.link.trim() : '';
        return link && link !== insert ? `${insert} (${link})` : insert;
    })
        .join('');
}
function collect(value, refDocIds) {
    if (value === null || value === undefined)
        return '';
    if (typeof value === 'string')
        return value;
    if (Array.isArray(value))
        return deltaText(value, refDocIds);
    if (typeof value !== 'object')
        return '';
    const record = value;
    for (const key of ['insert', 'text', 'content']) {
        if (typeof record[key] === 'string')
            return record[key];
    }
    for (const key of ['delta', 'ops']) {
        if (Array.isArray(record[key])) {
            return deltaText(record[key], refDocIds);
        }
    }
    for (const key of ['value', 'yText']) {
        if (record[key])
            return collect(record[key], refDocIds);
    }
    return '';
}
/**
 * The single conversion from a stored text value to search text. A value is a
 * string (Y.Text after `toJSON()`), a delta list (Y.Text after `toDelta()`) or
 * an object wrapping one of them. Only a delta list keeps inline references.
 */
function searchText(value) {
    const refDocIds = [];
    const text = collect(value, refDocIds).trim();
    return { text, refDocIds: [...new Set(refDocIds)] };
}
function plainText(value) {
    return searchText(value).text;
}
//# sourceMappingURL=text.js.map